import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Card, Image, Space, Tag, Tooltip, Typography } from "antd";
import { DeleteOutlined, EyeOutlined, InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";

const { Meta } = Card;
const { Text } = Typography;

const BannerCard = ({ banner, onDelete }) => {
  const { t } = useTranslation();

  const getOrientationColor = (orientation) => {
    return orientation === "horizontal" ? "blue" : "green";
  };

  const getOrientationLabel = (orientation) => {
    return orientation === "horizontal"
      ? t("campaigns.orientationHorizontal")
      : t("campaigns.orientationVertical");
  };

  const formatFileSize = (bytes) => {
    if (!bytes) return "—";
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  };

  const formatDimensions = () => {
    if (!banner.image_width || !banner.image_height) return "—";
    return `${banner.image_width} × ${banner.image_height} px`;
  };

  const formatAspectRatio = () => {
    if (!banner.aspect_ratio) return "—";
    return banner.aspect_ratio.toFixed(2);
  };

  const formatPeriod = () => {
    if (!banner.date_from || !banner.date_to) return "—";
    return `${moment(banner.date_from).format("DD.MM.YYYY")} - ${moment(banner.date_to).format("DD.MM.YYYY")}`;
  };

  return (
    <Card
      hoverable
      cover={
        <div
          style={{
            height: 200,
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f0f0f0",
          }}
        >
          <Image
            alt={`Banner ${banner.id}`}
            src={banner.image_url}
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              objectFit: "contain",
            }}
            preview={{
              mask: <EyeOutlined style={{ fontSize: 20 }} />,
              scaleStep: 2,
              minScale: 2,
              maxScale: 10,
            }}
            fallback="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Crect fill='%23ddd' width='200' height='200'/%3E%3Ctext x='50%25' y='50%25' text-anchor='middle' dy='.3em' fill='%23999'%3ENo Image%3C/text%3E%3C/svg%3E"
          />
        </div>
      }
      actions={[
        <Tooltip title={t("common.delete")}>
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => onDelete(banner.id)}
          />
        </Tooltip>,
      ]}
    >
      <Meta
        title={
          <Space direction="vertical" size="small" style={{ width: "100%" }}>
            <Space>
              <span>#{banner.order}</span>
              <Tag color={getOrientationColor(banner.banner_orientation_type)}>
                {getOrientationLabel(banner.banner_orientation_type)}
              </Tag>
            </Space>
          </Space>
        }
        description={
          <Space direction="vertical" size={2} style={{ width: "100%", fontSize: 12 }}>
            <Text type="secondary">{formatDimensions()}</Text>
            <Text type="secondary">{formatFileSize(banner.image_size_bytes)}</Text>
            <Text type="secondary">Ratio: {formatAspectRatio()}</Text>
            <Tooltip title={t("campaigns.activePeriod")}>
              <Text type="secondary" style={{ fontSize: 11 }}>
                📅 {formatPeriod()}
              </Text>
            </Tooltip>
          </Space>
        }
      />
    </Card>
  );
};

export default BannerCard;
